import { isEmpty, orderBy } from 'lodash'

const transformComponents = (components) => {
  if (isEmpty(components)) return

  const componentsFields = Object.keys(components).map((key, index) => ({
    name: key,
    description: components[key].subtitle,
    required: components[key].required,
    order: components[key].order ?? index,
    selected: true,
    label: components[key].label,
    placeholder: components[key].placeholder,
  }))

  return orderBy(componentsFields, 'order')
}

export default transformComponents
